export default __webpack_public_path__ + "static/media/102_glougloux.838c32b0.webp";